import { TAMRelationalData } from './types';

export const TAM_ENTITIES: Array<keyof TAMRelationalData> = ['datetimes', 'tickets'];
